import React, { FunctionComponent, ReactNode } from 'react';

interface FullScreenContentProps {
  player?: ReactNode;
  centerColumn: ReactNode;
  rightColumn?: ReactNode | null;
  renderAtBottom?: boolean;
}

export const FullScreenContent: FunctionComponent<FullScreenContentProps> = (
  props
) => {
  return (
    <div className="tw-flex-col sm:tw-flex-row mobile-landscape:tw-flex-row tw-flex tw-flex-1 sm:tw-px-8 sm:tw-pr-8 sm:tw-pb-8 sm:tw-space-x-8 tw-relative tw-z-50 [.embed_&]:tw-pb-0">
      <div className="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-text-center">
        <div className="tw-flex tw-flex-col tw-h-full tw-w-full">
          <div
            className={`tw-flex tw-flex-1 tw-justify-center ${
              props.renderAtBottom ? 'tw-items-end' : 'tw-items-center'
            } tw-w-full`}
          >
            {props.centerColumn}
          </div>
          {props.player && props.player}
        </div>
      </div>
      {props.rightColumn && props.rightColumn}
    </div>
  );
};
